var map = {
	"./da": 598,
	"./da.js": 598,
	"./de": 2882,
	"./de.js": 2882,
	"./en": 8902,
	"./en-au": 9955,
	"./en-au.js": 9955,
	"./en-ca": 7845,
	"./en-ca.js": 7845,
	"./en-in": 2146,
	"./en-in.js": 2146,
	"./en-us": 1693,
	"./en-us.js": 1693,
	"./en.js": 8902,
	"./es": 2805,
	"./es-mx": 6977,
	"./es-mx.js": 6977,
	"./es.js": 2805,
	"./fi": 5092,
	"./fi.js": 5092,
	"./fr": 7753,
	"./fr-ca": 5364,
	"./fr-ca.js": 5364,
	"./fr.js": 7753,
	"./hi": 2810,
	"./hi.js": 2810,
	"./index-map": 1930,
	"./index-map.ts": 1930,
	"./it": 1568,
	"./it.js": 1568,
	"./ja": 3096,
	"./ja.js": 3096,
	"./ko": 471,
	"./ko.js": 471,
	"./nb": 4961,
	"./nb.js": 4961,
	"./nl": 3179,
	"./nl.js": 3179,
	"./pl": 2001,
	"./pl.js": 2001,
	"./pt": 2473,
	"./pt-pt": 5428,
	"./pt-pt.js": 5428,
	"./pt.js": 2473,
	"./ru": 916,
	"./ru.js": 916,
	"./supported-languages": 1413,
	"./supported-languages.ts": 1413,
	"./sv": 3012,
	"./sv.js": 3012,
	"./zh": 2115,
	"./zh-Hant": 4519,
	"./zh-Hant.js": 4519,
	"./zh.js": 2115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5463;